// extracted by mini-css-extract-plugin
export default {"wrapper":"Wp","form":"Xp","option":"Yp","radio":"Zp","success":"_p","contest":"aq"};